import { render, staticRenderFns } from "./SuccessfulPaymentModal.vue?vue&type=template&id=485d8ed2&"
import script from "./SuccessfulPaymentModal.vue?vue&type=script&lang=js&"
export * from "./SuccessfulPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports